import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const styles = {
  para: {
    fontSize: 16
  },
  root: {
    display: "flex",
    justifyContent: "space-evenly",
    flexWrap: "wrap"
  },
  card: {
    minWidth: 275,
    maxWidth: 345,
    flex: 1,
    margin: 5
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  }
};

function SimpleCard(props) {
  const { classes } = props;

  return (
    <div>
      <Card>
        <CardContent>
          <div style={{ textAlign: "center" }}>
            <img
              style={{ borderRadius: "8px" }}
              src="./fablabzero.png"
              alt="logo"
              width="100%"
            />
          </div>
          <Typography variant="h5" align="center">
            Manoj Sahukar's Project Journal
          </Typography>
        </CardContent>
      </Card>
      <br />
      <div className={classes.root}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6" component="h2">
              About
            </Typography>
            <Typography className={classes.para} paragraph>
              Inquisitive, Skeptic, Transhumanist, Stoic, Freethinker,
              Deontological, Ambivert and Neoteric etc. are the words I use to
              describe myself more or less. I have B.Tech. in Mechanical
              Engineering and M.Tech in 'Entrepreneurship {"&"} Innovations'.
              Presently, I'm working as Start-up CTO at Aerogram Pvt Ltd, IIT
              Delhi. Before FA2019, I was a 'Business Developer' at Elegate.org,
              Cairo (Egypt).
            </Typography>
          </CardContent>
          <CardActions>
            {/* <Button
              target="_blank"
              href="https://manojsahukar.xyz"
              size="small"
            >
              Read More
            </Button> */}
          </CardActions>
        </Card>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6">My Lab</Typography>
            <Typography className={classes.para} paragraph>
              Vigyan Ashram is a center of Indian Institute of Education (IIE)
              Pune established by Dr.S.S. Kalbag in 1983. It's a modern version
              of old Gurukula systems of 'simple living and high thinking'.
              Dr.Neil Greshenfeld, (Director, Center of Bits and atoms, MIT
              (USA)) who created the Fab Lab, described Vigyan Ashram as ‘Fab
              Lab Zero’. VA-Fab lab was established through the interaction
              between Dr.Kalbag and Dr. Dr.Neil Greshenfeld in 2002. VA made
              slow and steady progress to master the use of Fab Lab to solve
              rural problems.
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              target="_blank"
              href="http://vigyanashram.com/"
              size="small"
            >
              Read More
            </Button>
          </CardActions>
        </Card>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h6">Project</Typography>
            <Typography className={classes.para} paragraph>
              LoRaWAN systems for Smart Farming in Rural India: Smart farming
              with environmental sensors is currently not feasible in rural
              India due to lack of wireless communication infrastructure. High
              data charges and energy requirements make 3G/4G mobile networks
              unusable. LoRaWAN is a cost effective solution for rural India for
              implementing data driven precision farming to increase yields.
            </Typography>
          </CardContent>
          <CardActions>
            {/* <Button
              target="_blank"
              href="http://vigyanashram.com/"
              size="small"
            >
              Read More
            </Button> */}
          </CardActions>
        </Card>
      </div>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
